import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { logger } from '../utils/logger.util';


/** Options pour ouvrir le lecteur vidéo global (streaming, compatible mobile). */
export interface VideoPlayerOpenOptions {
  title: string;
  /** Clé S3/MinIO — une URL présignée streamable sera récupérée. */
  s3Key?: string;
  /** URL déjà résolue (ex. campagne d'information) — prioritaire sur s3Key. */
  videoUrl?: string;
  contentType?: string;
  mimeType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VideoPlayerService {
  private readonly requestSubject = new BehaviorSubject<VideoPlayerOpenOptions | null>(null);

  /** État courant du lecteur (null = fermé). */
  readonly request$ = this.requestSubject.asObservable();

  /** Ouvre le lecteur vidéo plein écran (modale). */
  open(options: VideoPlayerOpenOptions): void {
    if (!options.videoUrl && !options.s3Key) {
      logger.warn('[VideoPlayerService] open() requiert videoUrl ou s3Key');
      return;
    }
    this.requestSubject.next(options);
  }

  close(): void {
    this.requestSubject.next(null);
  }
}
